import {
  SET_APP_VERSION,
  FETCH_FEATURES
} from './mutations-types'

export default {
  [SET_APP_VERSION] (state, payload) {
    state.appVersion = payload
  },
  [FETCH_FEATURES] (state, payload) {
    state.versions = Object.keys(payload.features)
    state.appVersion = payload.appVersion
    state.features = payload.features
  }
}
